import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {dashboardGetEventsCheckedin, dashboardGetEventsAuthor} from '../../../Events/actions';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import {withLocalize, Translate} from 'react-localize-redux';
import translations from '../../translations/translations_events';

class DashboardEventsSearch extends Component {
    state = {
        filter: '',
        userClick: false,
    };

    constructor(props) {
        super(props);

        this.props.addTranslation(translations);
    }

    componentDidMount() {
        this.setState({
            filter: this.props.filter,
        });
    }

    componentDidUpdate(prevProps, prevState) {
        const {dashboardEventsLoading} = this.props.events;

        if (this.state.filter !== prevState.filter && this.state.userClick && !dashboardEventsLoading) {
            this.props.changeFilter(this.state.filter);

            switch (this.state.filter) {
                case 'checkedin':
                    // Fetch the events where the current logged in user is checked in
                    this.props.dashboardGetEventsCheckedin(
                        1, // No offset
                        true, // Reset the search results / listing
                    );
                    break;
                case 'author':
                    // Fetch the events where the current logged in user is the author
                    this.props.dashboardGetEventsAuthor(
                        1, // No offset
                        true, // Reset the search results / listing
                    );
                    break;
                default:
                    break;
            }
        }
    }

    handleChange = e => {
        // NB: setState is asynchronous!
        // If we call the dashboardGetEventsCheckedin / dashboardGetEventsAuthor functions here, it'll be triggered before the state changed.
        // We'll use componentDidUpdate() => called after the state has changed

        this.setState({
            [e.target.name]: e.target.value,
            'userClick' : true,
        });
    };

    render() {
        const {dashboardEventsLoading} = this.props.events;

        return (
            <section id="events-search">
                <form autoComplete="off">
                    <div className="row row-search">
                        <div className="col col-6">
                            <FormControl disabled={dashboardEventsLoading}>
                                <InputLabel htmlFor="events-category">
                                    <Translate id="dashboard_events.filter_by" />
                                </InputLabel>
                                <Select
                                    value={this.state.filter}
                                    onChange={this.handleChange}
                                    inputProps={{
                                        name: 'filter',
                                        id: 'events-filter',
                                    }}
                                    autoWidth
                                >
                                    <MenuItem value="checkedin">
                                        <Translate id="dashboard_events.filter_events_checkedin" />
                                    </MenuItem>
                                    {/*<MenuItem value="author">
                                        <Translate id="dashboard_events.filter_events_author" />
                                    </MenuItem>*/}
                                </Select>
                            </FormControl>
                        </div>
                    </div>
                </form>
            </section>
        );
    }
}

DashboardEventsSearch.propTypes = {
    dashboardGetEventsCheckedin: PropTypes.func.isRequired,
    dashboardGetEventsAuthor: PropTypes.func.isRequired,
    changeFilter: PropTypes.func.isRequired,
    filter: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => ({
    events: state.events,
});

export default connect(mapStateToProps, {dashboardGetEventsCheckedin, dashboardGetEventsAuthor})(withLocalize(DashboardEventsSearch));



// WEBPACK FOOTER //
// ./src/features/Dashboard/components/Events/DashboardEventsSearch.js